import api from "./api";

const ServicePlanAPI = {
    getAll: () => api.get("/admin/service-plan/all"),
    getByServiceType: (typeId) => api.get(`/public/service-plan/type/${typeId}`),
    getById: (servicePlanId) => api.get(`/admin/service-plan/details/${servicePlanId}`),
    update: (params) => api.post(`/admin/service-plan/update`, params),
    getPlanFeatureByUser: () => api.get(`/admin/service-plan/feature`),
    getPlanDescription: () => api.get(`/admin/service-plan/description`),
    updPlanDescription: (params) => api.post(`/admin/service-plan/description`, params),
    checkExistFreePlan: () => api.get(`/admin/service-plan/check-exist-free-plan`),
    confirmFreePlan: () => api.get(`/admin/service-plan/confirm-free-plan`),
};

export default ServicePlanAPI;
